module.exports = __webpack_public_path__ + "img/processing-security-mir.f63ba1b4.svg";